export default __webpack_public_path__ + "static/media/nigel_sig.f08cbc09.png";